var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18433 20.4417L8.81767 20.35C-0.807332 16.4083 0.017668 3.94167 0.017668 3.75833L0.109335 2.93333H0.934335C5.151 2.93333 8.63433 0.366667 8.63433 0.366667L9.18433 0L9.73433 0.366667C9.73433 0.366667 13.2177 2.93333 17.4343 2.93333H18.2593L18.351 3.75833C18.351 3.85 19.176 16.4083 9.551 20.2583L9.18433 20.4417ZM1.851 4.76667C1.851 7.33333 2.401 15.4917 9.18433 18.5167C15.9677 15.5833 16.5177 7.425 16.5177 4.76667C13.126 4.49167 10.2843 2.93333 9.18433 2.2C8.08433 2.93333 5.24267 4.49167 1.851 4.76667Z",
    fill: "#1885CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18489 16.6834C3.13489 14.1168 3.68489 5.7751 3.68489 5.7751C6.70989 5.7751 9.18489 3.8501 9.18489 3.8501C9.18489 3.8501 11.6599 5.7751 14.6849 5.7751C14.6849 5.7751 15.2349 14.1168 9.18489 16.6834Z",
    fill: "#1885CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP12);
export default __webpack_public_path__ + "static/media/p12.ebafc9d054ab6a6b5a4de6add7a8db4d.svg";
export { ForwardRef as ReactComponent };